import FinanceView from '@/views/FinanceView.vue';
import { createRouter, createWebHistory } from 'vue-router'
import { watch } from 'vue'
import { useAuthStore } from '@/stores/authStore';
import HomeView from '@/views/HomeView.vue'
import Register from '@/views/Register.vue'
import Login from '@/views/Login.vue'
import MyAccount from '@/views/MyAccount.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import VerifyCode from '@/views/VerifyCode.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import AccountActivation from '@/views/AccountActivation.vue';
import EventDetails from '@/views/EventDetails.vue';
import Cart from '@/views/Cart.vue';
import Checkout from '@/views/Checkout.vue';
import PaymentView from '@/views/PaymentView.vue';
import PaymentSuccess from '@/views/PaymentSuccess.vue';
import MyOrders from '@/views/MyOrders.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import { updateThemeColor } from '@/utils/themeColorManager';
import { formatPageTitle, getBrandTitle } from '@/utils/branding';
import HowItWorksPage from '@/views/HowItWorksPage.vue';
import SecurityPrivacy from '@/views/SecurityPrivacy.vue';
import ContactPage from '@/views/ContactPage.vue';
import TermosDeUso from '@/views/legal/TermosDeUso.vue';
import PoliticaDePrivacidade from '@/views/legal/PoliticaDePrivacidade.vue';
import TermosDeSaque from '@/views/legal/TermosDeSaque.vue';

const routes = [
    {
      path: '/finance',
      name: 'FinanceView',
      component: FinanceView,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/dashboard',
      name: 'AdminDashboard',
      component: () => import('@/views/admin/AdminDashboard.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/withdrawals',
      name: 'AdminWithdrawals',
      component: () => import('@/views/admin/AdminWithdrawals.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/withdrawal-requests',
      name: 'AdminWithdrawalRequests',
      component: () => import('@/views/admin/AdminWithdrawalRequests.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/finance',
      name: 'AdminFinance',
      component: () => import('@/views/admin/AdminFinance.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/event-payouts',
      name: 'AdminEventPayouts',
      component: () => import('@/views/admin/AdminEventPayouts.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/catalog',
      name: 'AdminCatalog',
      component: () => import('@/views/admin/AdminCatalog.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, pageTitle: 'Admin | Catálogo' }
    },
    {
      path: '/admin/legal',
      name: 'AdminLegalDocuments',
      component: () => import('@/views/admin/AdminLegalDocuments.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, pageTitle: 'Admin | Documentos Legais' }
    },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { hideWhenAuth: true }
  },
  {
    path: '/organizer/onboarding/refresh',
    name: 'OrganizerOnboardingRefresh',
    component: () => import('@/views/OrganizerOnboardingRefresh.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/how-it-works',
    name: 'HowItWorksPage',
    component: HowItWorksPage
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { hideWhenAuth: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { hideWhenAuth: true }
  },
  {
    path: '/verify-code',
    name: 'VerifyCode',
    component: VerifyCode,
    meta: { hideWhenAuth: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { hideWhenAuth: true }
  },
  {
    path: '/activate-account',
    name: 'AccountActivation',
    component: AccountActivation,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-account/add',
    name: 'EventCreate',
    component: () => import('@/views/EventCreateV2.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/my-account/add-v2',
    redirect: '/my-account/add',
  },
  {
    path: '/my-account/:page',
    component: MyAccount,
    meta: { requiresAuth: true },
    props: true,    
  },  
  {
    path: '/meus-dados',
    redirect: '/my-account/profile',
    meta: { requiresAuth: true }
  },
  {
    path: '/my-account/events/:id/edit',
    name: 'EventEdit',
    component: () => import('@/views/EventCreateV2.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/event/:id',
    name: 'EventDetails',
    component: EventDetails,
    meta: { pageTitle: 'Lista de presentes' },
    props: true
  },
  {
    path: '/cart/:id',
    name: 'Cart',
    component: Cart,
    props: true
  },
  {
    path: '/checkout/:id',
    name: 'Checkout',
    component: Checkout,
    props: true
  },
  {
    path: '/checkout/:id/pay',
    name: 'PaymentView',
    component: PaymentView,
    props: true
  },
  {
    path: '/minhas-compras',
    name: 'MyOrders',
    component: MyOrders,
  },
  {
    path: '/terms-and-conditions',
    name: 'SecurityPrivacy',
    component: SecurityPrivacy
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage
  },
  {
    path: '/payment-success/:id',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    props: true
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccessNew',
    component: PaymentSuccess,
  },
  {
    path: '/payment/cancelled',
    name: 'PaymentCancelled',
    component: () => import('@/views/PaymentCancelled.vue')
  },
  {
    path: '/payment/expired',
    name: 'PaymentExpired',
    component: () => import('@/views/PaymentExpired.vue')
  },
  {
    path: '/payment/:id',
    name: 'Payment',
    component: () => import('@/views/Payment.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/termos-de-uso',
    name: 'TermosDeUso',
    component: TermosDeUso,
  },
  {
    path: '/politica-de-privacidade',
    name: 'PoliticaDePrivacidade',
    component: PoliticaDePrivacidade,
  },
  {
    path: '/termos-de-saque',
    name: 'TermosDeSaque',
    component: TermosDeSaque,
  },
  {
    path: '/:pathMatch(.*)*', 
    name: 'NotFound',
    component: NotFoundView 
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();

  if (!auth.authReady) {
    await new Promise(resolve => {
      const stop = watch(
        () => auth.authReady,
        (ready) => {
          if (ready) {
            stop();
            resolve();
          }
        }
      );
    });
  }

  if (to.path === '/my-account/pix') {
    return next({ path: '/my-account/bank', query: to.query });
  }

  const isAuthenticated = auth.isAuthenticated;

  // Proteção para rotas que exigem autenticação
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login');
  }

  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return next('/');
  }

  // Proteção para rotas que não devem ser acessadas quando o usuário já está logado
  if (to.meta.hideWhenAuth && isAuthenticated) {
    // Redireciona o usuário logado para a página inicial (ou dashboard)
    return next('/');
  }
  // Continua normalmente
  return next();
});


router.afterEach((to, from) => {
  const defaultAppColor = '#FF50A3';
  let colorToApply = defaultAppColor;

  const rawPageTitle = typeof to.meta?.pageTitle === 'function'
    ? to.meta.pageTitle(to)
    : to.meta?.pageTitle;

  if (typeof rawPageTitle === 'string' && rawPageTitle.trim()) {
    document.title = formatPageTitle(rawPageTitle);
  } else {
    document.title = getBrandTitle();
  }
  
  if (to.path.startsWith('/my-account/') && to.params.page === 'dashboard') {
    colorToApply = '#ff50a3';
  } else if (to.meta.themeColor) {    
    colorToApply = to.meta.themeColor;
  }  

  updateThemeColor(colorToApply);
});
export default router